import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';

export const CancelModalStyles = css`
  ${MainStyles}
  #red-text {
    color: #c04434;
  }

  p {
    text-align: center;
  }

  .cancel-button {
    margin-right: 5px;
  }
`;
